module.exports = __webpack_public_path__ + "static/media/nonfiction.71f3f07a.png";